import MessageModal from "@/MessageModal";

interface BusinessTimeType {
  cdDayOfWeek: string; // "MONDAY", "TUESDAY", etc.
  startTime: string; // "09:00:00"
  endTime: string; // "18:00:00"
  close: boolean; // 휴무 여부
}

interface BusinessHoursModalProps {
  isOpen: boolean;
  onClose: () => void;
  businessTimes: BusinessTimeType[];
}

const DAYS_OF_WEEK = [
  { korean: "월요일", english: "MONDAY" },
  { korean: "화요일", english: "TUESDAY" },
  { korean: "수요일", english: "WEDNESDAY" },
  { korean: "목요일", english: "THURSDAY" },
  { korean: "금요일", english: "FRIDAY" },
  { korean: "토요일", english: "SATURDAY" },
  { korean: "일요일", english: "SUNDAY" },
];

// 시간 포맷 변환: "09:00:00" -> "09:00"
const formatTime = (time: string) => {
  if (!time) return "";
  return time.substring(0, 5); // "09:00:00" -> "09:00"
};

export const BusinessHoursModal = ({
  isOpen,
  onClose,
  businessTimes,
}: BusinessHoursModalProps) => {
  // businessTimes를 요일별로 매핑
  const businessTimesByDay = businessTimes.reduce(
    (acc, time) => {
      acc[time.cdDayOfWeek] = time;
      return acc;
    },
    {} as Record<string, BusinessTimeType>
  );

  return (
    <MessageModal
      isOpen={isOpen}
      onRequestClose={onClose}
      showCloseButton={true}
      shouldCloseOnOverlayClick={true}
      className="px-3 py-4 w-[280px]"
    >
      <div className="mt-4 space-y-1.5">
        {DAYS_OF_WEEK.map((day) => {
          const businessTime = businessTimesByDay[day.english];
          
          // 휴무 여부 확인
          const isClosed = businessTime?.close ?? true;
          
          // 영업시간 표시
          const displayTime = isClosed
            ? "휴무"
            : businessTime
              ? `${formatTime(businessTime.startTime)} - ${formatTime(businessTime.endTime)}`
              : "휴무";

          return (
            <div key={day.english} className="flex justify-between items-center py-1.5">
              <span className="text-gray-700 font-s text-s">{day.korean}</span>
              <span className="text-gray-600 text-s">{displayTime}</span>
            </div>
          );
        })}
      </div>
    </MessageModal>
  );
};
